import request from '@/utils/request'

// 獲取
export function asigndocsInfo(query) {
  return request({
    url: '/api/asigndocs/asigndocsInfo',
    method: 'get',
    params: query
  })
}

// 新增
export function createAsigndocs(data) {
  return request({
    url: '/api/asigndocs/asigndocsInfo',
    method: 'post',
    data
  })
}
// 修改
export function updateAsigndocs(data) {
  return request({
    url: '/api/asigndocs/asigndocsInfo',
    method: 'put',
    data
  })
}

export function generateSignedDocs(data) {
  return request({
    url: '/api/asigndocs/generateSignedDocs',
    method: 'put',
    data
  })
}

export function deleteAsigndocs(id) {
  return request({
    url: '/api/asigndocs/asigndocsInfo/' + id,
    method: 'delete'
  })
}

export function sendToHCAEMR() {
  return request({
    url: '/api/asigndocs/sendToHCAEMR',
    method: 'post',
    data: {}
  })
}
